export const APPLICATION_VIEW_FEES = ({ fees }): any[] => [
  {
    key: 'percentage',
    value: fees?.percentage && `${fees?.percentage}%`,
    label: 'Fee %',
    fakeInputAdditionalClass: 'application-view-fees-width',
  },
  {
    key: 'feeAmount',
    value: fees?.feeAmount && `${fees?.feeAmount} USD`,
    label: 'Fee Amount',
    fakeInputAdditionalClass: 'application-view-fees-width',
  },
  {
    key: 'minFeeAmount',
    value: fees?.minFeeAmount && `${fees?.minFeeAmount} USD`,
    label: 'Min Fee Amount',
    fakeInputAdditionalClass: 'application-view-fees-width',
  },
  {
    key: 'chargeback',
    value: fees?.chargeback && `${fees?.chargeback} USD`,
    label: 'Chargeback fee',
    fakeInputAdditionalClass: 'application-view-fees-width',
  },
  {
    key: 'refundFee',
    value: fees?.refundFee && `${fees?.refundFee} USD`,
    label: 'Refund Fee',
    fakeInputAdditionalClass: 'application-view-fees-width',
  },
  {
    key: 'riskFee',
    value: fees?.riskFee && `${fees?.riskFee}%`,
    label: 'Risk Fee',
    fakeInputAdditionalClass: 'application-view-fees-width',
  },
];